import { deepChangeUid, getAllColsUidInLayoutComponent, handleFindLayoutComponentOptionsCols } from "utils"
import { primaryBigScreenGenerator as primarybigScreenGenerator } from "../store/modules/bigScreen/state"
import { primaryStageGenerator as primarystageGenerator } from "../store/modules/stage/state"
import { primaryAppStageGenerator as primaryappStageGenerator } from "../store/modules/appStage/state"
const mockStage = { primarybigScreenGenerator, primarystageGenerator, primaryappStageGenerator }
export function initStageLayout(val) {
  initStageList.call(this) //初始化stage的child，删除现有所有stage
  if (val) {
    //开启布局
    startCreateLayoutStage.call(this)
  } else {
    const primaryStageData = getPrimaryStageGeneratorData(this.request_prefix, {
      options: {
        background: {
          0: { color: this.request_prefix.includes("bigScreen") ? "rgb(0, 4, 58)" : "rgba(255,255,255,1)" }
        }
      }
    }) //获取当前request_prefix对应的stage默认children
    //关闭布局
    initStageConstruction.call(this, primaryStageData)
    this.$store.dispatch(this.request_prefix + "/changeAttribute", { option_name: "layoutOption", option_val: {} }) //清空布局配置项
  }
}
//该函数需要导出 以便于之后切换布局样式时的重载
export function startCreateLayoutStage(defalutRows = "layout1") {
  const stageData = getPrimaryStageGeneratorData(this.request_prefix, {
    options: {
      background: {
        0: { color: "rgba(0,0,0,0)" }
      }
    }
  })
  let rows = JSON.parse(JSON.stringify(primaryRows[defalutRows]))
  deepChangeUid(rows) //初始化布局所需配的布局置项，生成新的uid
  const allUid = getAllColsUidInLayoutComponent(rows) //获取所有的最底层cols
  initStageConstruction.call(this, stageData, allUid.length) //根据布局中的cols数量初始化stge
  allUid.forEach((uid, index) => {
    //用container_id将布局stage和cols进行绑定
    handleFindLayoutComponentOptionsCols(rows, uid).container_id = index
  })
  this.$store.dispatch(this.request_prefix + "/changeAttribute", {
    option_name: "layoutOption",
    option_val: {
      rows: rows,
      name: defalutRows,
      background: [
        {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.request_prefix.includes("bigScreen") ? "rgb(0, 4, 58)" : "rgba(255,255,255,1)"
        }
      ]
    }
  })
  // initStagePageLaoutData.call(this) //初始化布局所需配的布局置项
  // initLayoutColsDep.call(this, primaryStageData) //初始化布局与stage的依赖关系
}
//根据不同的布局样式初始化不同的stage布局配置项,并生成一排配置

function initStageList() {
  const stageList = this.$store.state[this.request_prefix].page.children
  stageList.forEach(stage => {
    this.$store.dispatch(this.request_prefix + "/deleteContainer", stage.container_id)
  })
}
//根据所需的默认stage数量初始化stage
function initStageConstruction(primaryStageData, len = 1) {
  this.$store.dispatch(this.request_prefix + "/changeAttribute", {
    option_name: "children",
    option_val: new Array(len).fill(primaryStageData).map((item, index) => {
      return Object.assign(JSON.parse(JSON.stringify(item)), { container_id: index })
    })
  })
  this.$store.dispatch(this.request_prefix + "/changeAttribute", {
    option_name: "height",
    option_val: 1080
  })
}

function getPrimaryStageGeneratorData(name, opt) {
  return new mockStage["primary" + name + "Generator"](opt)
}

//默认布局row数据
const primaryRows = {
  layout1: [
    {
      height: "15%",
      uid: "",
      cols: [
        {
          width: "100%",
          uid: ""
        }
      ]
    },
    {
      height: "60%",
      uid: "",
      cols: [
        {
          width: "25%",
          uid: ""
        },
        {
          width: "25%",
          uid: ""
        },
        {
          width: "25%",
          uid: ""
        },
        {
          width: "25%",
          uid: ""
        }
      ]
    },
    {
      height: "25%",
      uid: "",
      cols: [
        {
          width: "25%",
          uid: ""
        },
        {
          width: "50%",
          uid: ""
        },
        {
          width: "25%",
          uid: ""
        }
      ]
    }
  ],
  layout2: [
    {
      height: "15%",
      uid: "",
      cols: [
        {
          uid: "",
          width: "100%"
        }
      ]
    },
    {
      height: "28.3%",
      uid: "",
      cols: [
        { width: "20%", uid: "" },
        {
          width: "60%",
          uid: "",
          rows: [
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        },
        { width: "20%", uid: "" }
      ]
    },
    {
      height: "28.3%",
      uid: "",
      cols: [
        { width: "20%", uid: "" },
        { width: "60%", uid: "" },
        { width: "20%", uid: "" }
      ]
    },
    {
      height: "28.3%",
      uid: "",
      cols: [
        { width: "20%", uid: "" },
        { width: "60%", uid: "" },
        { width: "20%", uid: "" }
      ]
    }
  ],
  layout3: [
    {
      height: "15%",
      uid: "",
      cols: [
        {
          uid: "",
          width: "100%"
        }
      ]
    },
    {
      height: "85%",
      uid: "",
      cols: [
        {
          width: "33.33%",
          uid: "",
          rows: [
            {
              height: "16%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "50.66%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "33.33%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        },
        {
          width: "33.33%",
          uid: "",
          rows: [
            {
              height: "33.33%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "33.33%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "33.33%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        },
        {
          width: "33.33%",
          uid: "",
          rows: [
            {
              height: "33.33%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "33.33%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "33.33%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  layout4: [
    {
      height: "15%",
      uid: "",
      cols: [
        {
          width: "100%",
          uid: ""
        }
      ]
    },
    {
      height: "60%",
      uid: "",
      cols: [
        {
          width: "25%",
          uid: "",
          rows: [
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        },
        {
          width: "50%",
          uid: ""
        },
        {
          width: "25%",
          uid: "",
          rows: [
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        }
      ]
    },
    {
      height: "25%",
      uid: "",
      cols: [
        {
          width: "25%",
          uid: ""
        },
        {
          width: "50%",
          uid: ""
        },
        {
          width: "25%",
          uid: ""
        }
      ]
    }
  ],
  layout5: [
    {
      height: "15%",
      uid: "",
      cols: [
        {
          width: "100%",
          uid: ""
        }
      ]
    },
    {
      height: "60%",
      uid: "",
      cols: [
        {
          width: "25%",
          uid: "",
          rows: [
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        },
        {
          width: "50%",
          uid: "",
          rows: [
            {
              height: "20%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "80%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        },
        {
          width: "25%",
          uid: "",
          rows: [
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        }
      ]
    },
    {
      height: "25%",
      uid: "",
      cols: [
        {
          width: "25%",
          uid: ""
        },
        {
          width: "50%",
          uid: ""
        },
        {
          width: "25%",
          uid: ""
        }
      ]
    }
  ],
  layout6: [
    {
      height: "15%",
      uid: "",
      cols: [
        {
          width: "100%",
          uid: ""
        }
      ]
    },
    {
      height: "85%",
      uid: "",
      cols: [
        {
          width: "25%",
          uid: "",
          rows: [
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        },
        {
          width: "50%",
          uid: "",
          rows: [
            {
              height: "66%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "33%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        },
        {
          width: "25%",
          uid: "",
          rows: [
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            },
            {
              height: "50%",
              uid: "",
              cols: [
                {
                  width: "100%",
                  uid: ""
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  layout7: [
    {
      height: "100%",
      uid: "",
      cols: [
        {
          width: "100%",
          uid: ""
        }
      ]
    }
  ]
}
